exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".UBMZVeXuHQczOpOz9SWgu{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:31px}", ""]);
// Exports
exports.locals = {
	"container": "UBMZVeXuHQczOpOz9SWgu"
};